import { NoResultFound } from 'components'

const PageNotFound = () => {
    return (
        <NoResultFound message="Page not found" />
    )
}

export default PageNotFound